import { BACKGROUND_TASK_STATES } from "@api/progress-api/progress-api-constants";
import { isBackgroundTaskStateUpdate } from "@api/progress-api/progress-api-type-guards";
import {
  BackgroundTask,
  BackgroundTaskStates,
} from "@api/progress-api/progress-api-types";

/** Task states that indicate a background task has finished (no longer in progress) */
const FINISHED_TASK_STATES: BackgroundTaskStates[] = [
  BACKGROUND_TASK_STATES.Succeeded,
  BACKGROUND_TASK_STATES.Aborted,
  BACKGROUND_TASK_STATES.Failed,
];

/**
 * @returns whether the background task has finished, i.e. its latest status is a
 * state update in a terminal state. Tasks reporting a progress update are still
 * running and therefore not considered finished.
 * @param task the background task to check
 */
function isTaskFinished(task: BackgroundTask): boolean {
  return (
    isBackgroundTaskStateUpdate(task.status) &&
    FINISHED_TASK_STATES.includes(task.status.state)
  );
}

/**
 * @returns the number of background tasks that are currently in progress (not finished yet)
 * @param tasks the list of background tasks to check
 */
export function countTasksInProgress(tasks: BackgroundTask[]): number {
  return tasks.filter((task) => !isTaskFinished(task)).length;
}
